import React from 'react';
import { PublicConfigContext, type PublicConfig } from './publicConfigContextInstance';

export type { PublicConfig } from './publicConfigContextInstance';

interface ProviderProps {
  value: PublicConfig;
  children: React.ReactNode;
}

export const PublicConfigProvider: React.FC<ProviderProps> = ({ value, children }) => (
  <PublicConfigContext.Provider value={value}>{children}</PublicConfigContext.Provider>
);
